import { render, staticRenderFns } from "./DialogEditAddress.vue?vue&type=template&id=6fdce543&scoped=true"
import script from "./DialogEditAddress.vue?vue&type=script&lang=js"
export * from "./DialogEditAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdce543",
  null
  
)

export default component.exports